<ng-container [formGroup]="form">
    <div class="row">
        <div class="col-6">
            <app-datepicker
                formControlName="date"
                [label]="dateLabel"
                [myDatePickerOptions]="myDatePickerOptions"
                [required]="required"
                [submitted]="submitted"
                (onClear)="onClear()"
            ></app-datepicker>
            <div class="mat-form-field-description mb-3 pr-5">
                <div class="form-fill-error error-datepicker" *ngIf="form.controls.date.invalid && form.controls.date.touched">Please provide Date</div>
            </div>
        </div>
        <div class="col-6">
            <mdb-form-control class="form-fill form-fill-datapicker">
                <input
                    formControlName="time"
                    mdbInput
                    [readonly]="true"
                    type="text"
                    id="form1"
                    class="form-control form-control-datapicker"
                    [mdbTimepicker]="timepicker"
                    (click)="timepicker.open()"
                />
                <label mdbLabel class="form-label form-label-datapicker" for="form1">{{timeLabel}}</label>
                <mdb-timepicker (timeChanged)="onTimeChange($event)" #timepicker></mdb-timepicker>
            </mdb-form-control>
            <span class="form-fill-error error-datetime" *ngIf="form.controls.time.invalid && form.controls.time.touched">Please provide Time</span>
        </div>
    </div>
</ng-container>
